<template>
  <div class="input-type-text">
    <label v-if="label" class="text_label" v-text="label" />
    <input
      v-model="inputValue"
      class="inputClasses"
      type="checkbox"
      :disabled="disabled"
      @focus="hasFocus = true"
      @blur="hasFocus = false"
    />
     <info v-if="infoText" :infoText="infoText" />
    <div class="error-message" v-if="errorMsg">{{errorMsg}}</div>
  </div>
</template>

<script>
import Info from "./Info";

export default {
  components: { Info },
  props: {
    label: {
      type: String,
      default: null
    },
    infoText: {
      type: String,
      default: null
    },
    isValid: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
	},
	errorMsg: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  computed: {
    inputClasses() {
      let res = "is-invalid";
      if (!this.isInvalid) res = "is-valid";

      return res;
    }
  },
  watch: {
    value() {
      this.inputValue = this.value;
    },
    inputValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>


<style scoped>

input{
  width: 17px;
  height: 17px;
}

.is-invalid {
  border-color: red;
}
.is-valid {
  border-color: black;

}

.text_label{
  margin-right: 0.5em;
  width: 45%;
}

.error-message{
		flex: 2;
		width: 100%;
		font-size: 12px;
		color: #ff4e2b;
		font-style: italic;
	}
</style>
